import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { MdKeyboardArrowRight as ArrowRightIcon } from 'react-icons/md';

const getRightIcon = (header, rightIcon) => {
  if (rightIcon) {
    return rightIcon;
  }
  if (header) {
    return <ArrowRightIcon className="section-header-icon" />;
  }
  return null;
};

const ContentButton = ({ className, to, onClick, history, children, icon, rightIcon, header }) => (
  <button
    // eslint-disable-next-line react/jsx-no-bind
    onClick={onClick ? onClick : () => history.push(to)}
    className={classnames('link-button', className, header ? 'section-header' : 'section-button')}
  >
    <div className="ContentButton-leftContainer">
      {icon}
      <span className="ContentButton-children">{children}</span>
    </div>
    {getRightIcon(header, rightIcon)}
  </button>
);

ContentButton.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node,
  rightIcon: PropTypes.node,
  children: PropTypes.node,
  header: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(ContentButton);
